/* eslint-disable semi */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
const dropdownMenu = [
  {
    mainTitle: "대시보드",
  },
  {
    mainTitle: "주차장 관리",
    parkingSubMenu: "주차장 설정",
  },
  {
    mainTitle: "미납 관리",
    defaultSubMenu1: "미납 차량 정보",
    defaultSubMenu2: "미납 처리",
  },
  {
    mainTitle: "압류 관리",
    seizeSubMenu: "압류 차량 정보",
  },
  {
    mainTitle: "수납 관리",
    receiptSubMenu: "수납 내역 관리",
  },
  {
    mainTitle: "고지서 관리",
    billSubMenu: "고지서 발송 관리",
  },
  {
    mainTitle: "SMS 발송관리",
    smsSendPostSubMenu1: "메시지 발송",
    smsSendPostSubMenu2: "메시지 발송 이력",
  },
  {
    mainTitle: "시스템 관리",
  },
];
// eslint-disable-next-line semi
export default dropdownMenu;
